// Stripe configuration for AI for SMEs - Chamber Program

export const LEARN_STRIPE_CONFIG = {
  products: {
    online: {
      productId: 'prod_TLC9TYAmvyEqBF',
      name: 'AI for SMEs - Online Course',
      price: 50,
      description: 'Self-paced online course with lifetime access',
      paymentLink: '', // Add your Stripe payment link here (e.g., https://buy.stripe.com/...)
    },
    faceToFace: {
      productId: 'prod_TLCEg7kiGkmAZW',
      name: 'AI for SMEs - Face-to-Face Workshop',
      price: 200,
      description: 'In-person workshop with expert facilitators',
      paymentLink: '', // Add your Stripe payment link here (e.g., https://buy.stripe.com/...)
    },
  },
  taxRate: 0.15,
  currency: 'nzd',
} as const;

// Helper to calculate total price including GST for display
export const calculateTotalWithGST = (basePrice: number): number => {
  return basePrice * (1 + LEARN_STRIPE_CONFIG.taxRate);
};
